import styled, {css, keyframes} from 'styled-components';
import {
  BREAKPOINTS,
  COLORS,
  ComponentMStyling,
  ComponentSStyling,
  ComponentTextStyle,
  ComponentXSStyling,
  focusStyles,
  scrollBarStyling,
  Z_INDEXES
} from '../../styles';
import {NavLink} from 'react-router-dom';
import {Size} from '../../types';

export const RowLayout = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.button`
  background-color: ${COLORS.white};
  font-weight: bold;
  border: 0;
`;

const flowLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const flowRight = keyframes`
  0% {
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100%);
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
`;

export const Menu = styled.div`
  height: 100%;
  background-color: ${COLORS.white};
  box-sizing: border-box;
  right: 0;
  top: 0;
  position: absolute;
  z-index: ${Z_INDEXES.off_canvas};
  align-items: center;

  width: 320px;

  ${BREAKPOINTS.SMALL} {
    width: 400px;
  }

  .open & {
    visibility: visible;
    display: flex;
    animation: ${flowLeft} 0.3s ease-in-out;
  }

  .closed & {
    visibility: hidden;
    animation: ${flowRight} 0.3s ease-in-out;
  }
`;

export const Right = styled.div`
  display: flex;
  margin-left: auto;
`;

export const SiteName = styled.span`
  color: ${COLORS.neutral_600};
  font-weight: bold;
  font-size: 14px;
  margin-left: 4px;
`;

export const MenuSection = styled.li`
  margin-top: 16px;

  .disabled-link {
    color: #21212150;
    pointer-events: none;
    key-events: none;
  }
`;

export const MenuSectionList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    width: 80%;
    height: 48px;
    margin: 0 auto 0 12px;

    a {
      height: 100%;
    }
  }
`;

export const UserMenuSectionListStyling = css`
  li {
    position: relative;
  }

  li:hover:not(.disabled) {
    z-index: ${Z_INDEXES.hover};
    background-color: ${COLORS.primary_20};

    a {
      color: ${COLORS.primary_600};
    }

    svg {
      color: ${COLORS.primary_600};
    }
  }

  li:focus-within:not(.disabled) {
    z-index: ${Z_INDEXES.focus};

    ${focusStyles}
    a {
      outline: none;
    }
  }

  li:active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    background: ${COLORS.primary_100};

    a {
      color: ${COLORS.primary_800};
    }

    svg {
      color: ${COLORS.primary_800};
    }
  }

  .disabled {
    a {
      color: ${COLORS.neutral_300};
    }

    svg {
      color: ${COLORS.neutral_300};
    }

    background-color: ${COLORS.neutral_100};
  }
`;

export const MenuLink = styled(NavLink)`
  border: none;
  background: transparent;
  margin: auto;

  box-sizing: border-box;

  ${ComponentMStyling(ComponentTextStyle.Regular, COLORS.black)}

  text-decoration: none;
  text-align: center;
  align-items: center;
  display: flex;
`;

export const flowDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MobileMenuWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  flex-flow: column;
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const ScrollableContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100%;

  &.scrollable {
    margin-right: 6px;
    padding-right: 10px;
  }

  ${scrollBarStyling(Size.Small)}
  ::-webkit-scrollbar-track {
    margin: 8px;
  }
`;

export const MobileHeaderText = styled.div`
  ${ComponentSStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  ${BREAKPOINTS.SMALL} {
    ${ComponentMStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  }
`;
export const MobileHeaderNote = styled.div`
  word-break: break-all;
  ${ComponentXSStyling(ComponentTextStyle.Regular, COLORS.neutral_600)}
`;

export const MobileHeaderContainer = styled.div`
  margin: 0 24px;
  padding-bottom: 8px;
  box-sizing: border-box;
  border-bottom: 1px solid ${COLORS.neutral_200};
  display: flex;
  flex-direction: column;
`;
